import dayjs from 'dayjs'
import { Suspense } from 'react'
import { Spinner } from 'react-bootstrap'
import { Navigate, Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useAuth } from '../auth'
import { User } from '../types'
import { NavMenu } from './NavMenu'

type AuthLayoutProps = {
  redirect_to: string
}

function isValidUser(user: User | null): boolean {
  if (!user) return false

  if (user.expiration_date) {
    const expirationDate = dayjs(user.expiration_date)
    if (!expirationDate.isValid() || expirationDate.isBefore(dayjs(), 'day')) {
      return false
    }
  }

  return true
}

export function AuthLayout({ redirect_to }: AuthLayoutProps) {
  const { user } = useAuth()

  if (!user) {
    return <Navigate to={redirect_to} replace />
  }

  if (!isValidUser(user)) {
    return <Navigate to="/expired" replace />
  }

  return (
    <div className="h-100 w-100 with-nav-menu">
      <NavMenu></NavMenu>
      <div className="h-100 w-100">
        <Suspense
          fallback={
            <div className="page d-flex justify-content-center align-items-center">
              <Spinner animation="border" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
      <ToastContainer />
    </div>
  )
}
